namespace $ { $mol_style_attach( "mol/row/demo/products/products.view.css",
 "\n[mol_row_demo_products_products] {\n\tdisplay: grid;\n\tgrid-template-columns: repeat( auto-fit, minmax( 8rem, 1fr ) );\n}\n\n[mol_row_demo_products_product] {\n\talign-self: stretch;\n}\n"
) }